import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getAdminSupportLogsAction = createAsyncThunk(
    'get-admin-support-logs',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/get-admin-support-logs`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getAdminSupportLogsSlice = createSlice({
    name: 'get-admin-support-logs',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getAdminSupportLogsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getAdminSupportLogsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getAdminSupportLogsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getAdminSupportLogsReducer = getAdminSupportLogsSlice.reducer